import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Spinner, Link } from "components/common";
import useReceivedBy from "forwarder/message-details/useReceivedBy";
import ForwarderRoutes from "forwarder/Routes";
const ForwarderReceivedBy = ({ inputId, forwarderNodeId }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const { forwarder, input, isLoading } = useReceivedBy(inputId, forwarderNodeId);
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("dt", null, t("forwarder_received_by.label")), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "forwarder_received_by.description",
      values: { input: input == null ? void 0 : input.title, forwarder: forwarder == null ? void 0 : forwarder.title },
      components: {
        em: /* @__PURE__ */ React.createElement("em", null),
        forwarderLink: /* @__PURE__ */ React.createElement(Link, { to: ForwarderRoutes.details(forwarder == null ? void 0 : forwarder.id) })
      }
    }
  )));
};
export default ForwarderReceivedBy;
